module.exports = __webpack_public_path__ + "static/media/main idea.deda52c6.mp3";